<template>
<div id="fiche-article">
    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Fiche Article</h4>
            </div>
        </div>
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="vx-row w-full">

                    <div class="flex mb-4 vx-col md:w-full">

                        <div class="vx-col md:w-1/2 sm:w-1/1 w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Code Article</label>

                                <div class="mt-2">
                                    <vs-input readonly v-model="selected.code" class="w-full" icon-pack="feather" icon="icon-home" />

                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/2 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Désignation</label>

                                <div class="mt-2">
                                    <vs-input readonly class="w-full" v-model="selected.designation" icon-pack="feather" icon="icon-clock" />

                                </div>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->

                    </div>

                    <div class="flex mb-4 vx-col md:w-full">

                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Fournisseur</label>

                                <div class="mt-2">
                                    <vs-input readonly class="w-full" v-model="selected.fournisseur" icon-pack="feather" icon="icon-clock" />

                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">DCI</label>

                                <div class="mt-2">
                                    <vs-input readonly v-model="selected.dci" class="w-full" icon-pack="feather" icon="icon-home" />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex mb-4 vx-col md:w-full">

                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Catégorie</label>

                                <div class="mt-2">
                                    <vs-input readonly class="w-full" v-model="selected.categorie" icon-pack="feather" icon="icon-clock" />

                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Code à bare</label>

                                <div class="mt-2">
                                    <vs-input readonly v-model="selected.barcode" class="w-full" icon-pack="feather" icon="icon-home" />

                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="flex mb-4 pt-10 vx-col md:w-full ">

                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2 wrapper">
                            <div class="box">
                                <div class="js--image-preview">

                                    <img :src="'data:image/jpeg;base64,'+imgURL1" height="200" v-if="imgURL1">
                                </div>
                                <div class="upload-options">
                                    <div class="form-group">
                                        <label>
                                            <input ref="file1" type="file" class="image-upload" accept="image/*" @change="preview1()" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2 wrapper">
                            <div class="box">
                                <div class="js--image-preview">

                                    <img :src="'data:image/jpeg;base64,'+imgURL2" height="200" v-if="imgURL2">
                                </div>
                                <div class="upload-options">
                                    <div class="form-group">
                                        <label>
                                            <input ref="file2" type="file" class="image-upload" accept="image/*" @change="preview2()" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary  px-2 wrapper">
                            <div class="box">
                                <div class="js--image-preview">

                                    <img :src="'data:image/jpeg;base64,'+imgURL3" height="200" v-if="imgURL2">
                                </div>
                                <div class="upload-options">
                                    <div class="form-group">
                                        <label>
                                            <input ref="file3" type="file" class="image-upload" accept="image/*" @change.stop="preview3()" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="  flex mb-4 vx-col md:w-full ">

                        <div class="vx-col   w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">

                                <div class="mt-2 float-right">

                                    <vs-button :disabled="selected.etat" @click="SaveArticle()">enregistrer</vs-button>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col  md:w-1/5 sm:w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">

                                <div class="mt-2 float-right">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import articleServ from '@/http/requests/article/index.js'
export default {
    data() {
        return {
            codeArticle: null,
            imgURL1: '',
            imgURL2: '',
            imgURL3: '',
            isItemREady: false,

        }
    },
    computed: {

        selected: function () {

            return this.$store.state.article.articles.filter(el => el.code == this.codeArticle)[0]
        },
    },
    methods: {
        loadItemImage() {
            articleServ.getimageByCodeArticle(this.codeArticle).then(response => {
                if (response.data.length > 0) {
                    this.imgURL1 = response.data[0].content
                    if (response.data.length > 1)
                        this.imgURL2 = response.data[1].content
                    if (response.data.length > 2)
                        this.imgURL3 = response.data[2].content
                }
            })
        },
        SaveArticle() {
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Mis à jour Fiche Article`,
                text: "Voulez vous mettre à jour les images de l'article " + this.codeArticle,
                acceptText: "OUI",
                cancelText: "Annuler",
                accept: this.onUpdateArticle
            });

        },
        onUpdateArticle() {
            let data = {
                image1: this.imgURL1,
                image2: this.imgURL2,
                image3: this.imgURL3,
            }
            this.$vs.loading()
            articleServ.addImagestoArticles(this.codeArticle, data).then(() => {
                this.$vs.loading.close()

                this.$swal.fire({
                    position: "absolute",
                    icon: "info",
                    title: "Mis à jour avec succés",
                    showConfirmButton: true,
                    timer: 2500
                });
            }).catch(error => {
                console.log(error.response)
                this.$vs.loading.close()
                this.$swal.fire({
                    position: "absolute",
                    icon: "warning",
                    title: "Erreur : " + error.response.data,
                    showConfirmButton: true,
                    timer: 2500
                });
            })
        },
        preview1() {

            let files = this.$refs.file1.files;
            if (files.length === 0) {
                return;
            }
            const currentFileUpload = files.item(0);
            const fileReader = new FileReader();
            fileReader.onload = this._handleReaderLoaded1.bind(this);
            fileReader.readAsBinaryString(currentFileUpload);
        },
        _handleReaderLoaded1(readerEvt) {
            const binaryString = readerEvt.target.result;
            let filestring = btoa(binaryString); // Converting binary string data.

            this.imgURL1 = filestring;
        },
        preview2() {

            let files = this.$refs.file2.files;
            if (files.length === 0) {
                return;
            }
            const currentFileUpload = files.item(0);
            const fileReader = new FileReader();
            fileReader.onload = this._handleReaderLoaded2.bind(this);
            fileReader.readAsBinaryString(currentFileUpload);
        },
        _handleReaderLoaded2(readerEvt) {
            const binaryString = readerEvt.target.result;
            const filestring = btoa(binaryString); // Converting binary string data.

            this.imgURL2 = filestring;
        },
        preview3() {

            const files = this.$refs.file3.files;
            if (files.length === 0) {
                return;
            }
            const currentFileUpload = files.item(0);
            const fileReader = new FileReader();
            fileReader.onload = this._handleReaderLoaded3.bind(this);
            fileReader.readAsBinaryString(currentFileUpload);
        },
        _handleReaderLoaded3(readerEvt) {
            const binaryString = readerEvt.target.result;
            const filestring = btoa(binaryString); // Converting binary string data.

            this.imgURL3 = filestring;
        }
    },
    created() {
        if (this.$route.params.article_id == null)
            this.$router.push({
                name: 'page-error-404'
            })
        this.codeArticle = this.$route.params.article_id

        this.loadItemImage()
        if (this.$store.state.article.articles.length > 0) {

            this.isItemREady = true;
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "article/UPDATE_ARTICLE") {
                    this.isItemREady = true;
                }
            });
        }

    },
    mounted() {}

}
</script>

<style>
.box {
    display: block;
    width: 200px;
    height: 150px;
    margin: 10px;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -webkit-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow: hidden;
}

.js--image-preview {
    height: 100px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: white;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.upload-options {
    position: relative;
    height: 75px;
    background-color: #1B95E0;
    cursor: pointer;
    overflow: hidden;
    text-align: center;
    -webkit-transition: background-color ease-in-out 150ms;
    transition: background-color ease-in-out 150ms;
}

.upload-options:hover {
    background-color: #48AAE6;
}

.upload-options input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.upload-options label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-weight: 400;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
}

.upload-options label::after {
    content: 'add';
    font-family: 'Material Icons';
    position: absolute;
    font-size: 2.5rem;
    color: #e6e6e6;
    top: calc(50% - 2.5rem);
    left: calc(50% - 1.25rem);
    z-index: 0;
}

.upload-options label span {
    display: inline-block;
    width: 150px;
    height: 150px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
    text-align: center;
}

.upload-options label span:hover i.material-icons {
    color: lightgray;
}

.wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
</style>
